// @ts-nocheck

import { useEffect } from "react";

const PIXEL_ID = "a2_hrvh2gzevoql";
const TRACK_EVENT = "PageVisit";

function loadScript() {
  (function (w, d) {
    if (!w.rdt) {
      var p = (w.rdt = function () {
        p.sendEvent
          ? p.sendEvent.apply(p, arguments)
          : p.callQueue.push(arguments);
      });
      p.callQueue = [];
      var t = d.createElement("script");
      t.src = "https://www.redditstatic.com/ads/pixel.js";
      t.async = true;
      var s = d.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(t, s);
    }
  })(window, document);

  window.rdt("init", PIXEL_ID);
  window.rdt("track", TRACK_EVENT);
}

function useRedditPixel(enabled = false, timeout = 0) {
  useEffect(() => {
    if (!enabled) return;

    const timeoutId = window.setTimeout(loadScript, timeout);

    return () => window.clearTimeout(timeoutId);
  }, [enabled, timeout]);
}

export default useRedditPixel;
